import React from 'react'
import classNames from 'classnames'

import './Divider.scss'

/**
 * @import import { Divider } from '@/components/dividers/Divider'
 * @param {object} props
 * @param {React.ReactNode} [props.children] Label rendered in the middle of the divider line
 * @param {string} [props.className] Additional classes on the divider element
 */
export const Divider = ({ children, className }) => {
  if (children) {
    return (
      <div className={classNames('divider-labeled', className)}>
        <span>{children}</span>
      </div>
    )
  }

  return <hr className={classNames('divider', className)} />
}
